module.exports = __webpack_public_path__ + "img/communication.ceb0adf6.jpg";